import { OutgoingRequest } from '@wui/jssip/lib/SIPMessage'
import { Subscriber } from '@wui/jssip/lib/Subscriber'
import { defineStore } from 'pinia'
import { ref, watchEffect } from 'vue'

import { useStoreContacts } from '@/entities/contact'
import { CallStatusState } from '@/entities/pickup-call'
import { notifyBodyParser, STATE, useWebRTC } from '@/entities/webrtc'

import { NotifyEventData } from '@/shared/components/notifications'
import { useCallsNotifications } from '@/shared/composables/calls-notifications'
import { useCurrentUser } from '@/shared/composables/current-user'
import { sleep } from '@/shared/utils/main-thread'

export const useCurrentUserOtherTerminalSessionsStore = defineStore('current-user-other-terminal-sessions-store', () => {
  const uaSubscriber = ref<Subscriber | undefined>()
  const { subscribe, registered, sessions } = useWebRTC()
  const { currentUser } = useCurrentUser()
  const { add, removeByType } = useCallsNotifications()

  watchEffect(() => {
    const currentUserInternalNumber = currentUser.value?.internalNumber
    if (registered.value && currentUserInternalNumber) {
      uaSubscriber.value = subscribe(currentUserInternalNumber)
      uaSubscriber.value.on('notify', async (isFinal: boolean, notify: OutgoingRequest, body: string) => {
        const parsedBody = notifyBodyParser(body)
        const callId = parsedBody.callId

        if (parsedBody.remote === CallStatusState.CONFIRMED && parsedBody.callFromNumber && callId) {
          const session = [...sessions.value.values()].find((session) => session.sessionId.startsWith(callId))
          if (session) {
            await sleep(2000) // SIP Notify received earlier then session state update from RINGING to CANCELLED
            if (session && session.sessionState.value <= STATE.CONNECTED) {
              return
            }
          }
          const { callFromName, callFromNumber, internalNumber } = parsedBody
          const currentUserName = currentUser.value?.name ?? currentUserInternalNumber
          const fromName = (useStoreContacts().findByInternalNumber(callFromNumber)?.name ?? callFromName) as string
          const notifyEvent: NotifyEventData = {
            target: internalNumber,
            targetName: currentUserName,
            from: callFromNumber,
            fromName,
            callId,
          }
          add(notifyEvent, 'self-pickup')
        } else {
          removeByType('self-pickup')
        }
      })
    } else {
      uaSubscriber.value?.removeAllListeners()
    }
  })


  return {
  }
})
